import type { CSSProperties } from "react";
/** Stroke icons used throughout the Hearthdesk interface. */
const PATHS = {
  inbox: "M3 13h5l1.5 2.5h5L16 13h5 M5.5 5h13L21 13v6H3v-6z",
  mine: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21c0-4 3.6-6 8-6s8 2 8 6",
  unassigned: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21c0-4 3.6-6 8-6 M16 16l5 5 M21 16l-5 5",
  ai: "M12 3c1 4-3 5-3 8 0 1 1 2 2 2-1-3 3-4 3-7 4 4 6 7 4 11a7 7 0 0 1-12-1c-1-4 2-6 6-13z",
  clock: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M12 7v5l3 2",
  check: "M20 6 9 17l-5-5",
  chat: "M21 12a8 8 0 0 1-11.6 7.1L4 21l1.9-5.4A8 8 0 1 1 21 12z",
  mail: "M3 5h18v14H3z M3 6l9 7 9-7",
  globe: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M3 12h18 M12 3c2.5 2.5 3.8 5.5 3.8 9s-1.3 6.5-3.8 9 M12 3C9.5 5.5 8.2 8.5 8.2 12s1.3 6.5 3.8 9",
  alert: "M12 3 2 20h20z M12 10v4 M12 17h.01",
  sun: "M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z M12 2v2 M12 20v2 M4.9 4.9l1.4 1.4 M17.7 17.7l1.4 1.4 M2 12h2 M20 12h2 M4.9 19.1l1.4-1.4 M17.7 6.3l1.4-1.4",
  moon: "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z",
  refresh: "M21 12a9 9 0 1 1-2.6-6.4L21 8 M21 3v5h-5",
  hand: "M18 11V6a2 2 0 0 0-4 0v5 M14 10V4a2 2 0 0 0-4 0v6 M10 10.5V6a2 2 0 0 0-4 0v8a8 8 0 0 0 16 0v-3a2 2 0 0 0-4 0",
  plug: "M9 2v5 M15 2v5 M6 7h12v4a6 6 0 0 1-12 0z M12 17v5",
  off: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M8 12h8",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21c0-4 3.6-6 8-6s8 2 8 6",
  users: "M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M2 21c0-4 3.1-6 7-6s7 2 7 6 M16 3.5a4 4 0 0 1 0 7 M22 21c0-3-1.7-4.9-4-5.6",
  x: "M18 6 6 18 M6 6l12 12",
  book: "M4 4.5A1.5 1.5 0 0 1 5.5 3H20v15H5.5A1.5 1.5 0 0 0 4 19.5z M4 19.5A1.5 1.5 0 0 0 5.5 21H20v-3",
  customers: "M4 4h16v16H4z M9 10a3 3 0 1 0 6 0 3 3 0 0 0-6 0 M7.5 18c1-2.3 2.6-3.3 4.5-3.3s3.5 1 4.5 3.3",
  analytics: "M4 20V10 M10 20V4 M16 20v-7 M22 20H2",
  bolt: "M13 2 4 14h7l-1 8 9-12h-7z",
  settings: "M4 6h9 M17 6h3 M4 12h3 M11 12h9 M4 18h11 M19 18h1 M15 4v4 M9 10v4 M17 16v4",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z M21 21l-4.3-4.3",
  updown: "M8 9l4-4 4 4 M8 15l4 4 4-4",
  chevronDown: "M6 9l6 6 6-6",
  chevronRight: "M9 6l6 6-6 6",
  chevronLeft: "M15 6l-6 6 6 6",
  plus: "M12 5v14 M5 12h14",
  send: "M22 2 11 13 M22 2l-7 20-4-9-9-4z",
  paperclip: "M21 11.5 12.5 20a5 5 0 0 1-7-7L14 4.5a3.3 3.3 0 0 1 4.7 4.7L10.2 17.7a1.7 1.7 0 0 1-2.4-2.4L15.5 7.6",
  lock: "M5 11h14v10H5z M8 11V7a4 4 0 0 1 8 0v4",
  reply: "M9 14 4 9l5-5 M4 9h10a6 6 0 0 1 6 6v5",
  code: "M16 18l6-6-6-6 M8 6l-6 6 6 6",
  bold: "M6 4h8a4 4 0 0 1 0 8H6z M6 12h9a4 4 0 0 1 0 8H6z",
  italic: "M19 4h-9 M14 20H5 M15 4 9 20",
  link: "M10 13a5 5 0 0 0 7.5.5l3-3a5 5 0 0 0-7-7l-1.7 1.7 M14 11a5 5 0 0 0-7.5-.5l-3 3a5 5 0 0 0 7 7l1.7-1.7",
  wand: "M15 4V2 M15 16v-2 M8 9h2 M20 9h2 M17.8 11.8 19 13 M17.8 6.2 19 5 M3 21l9-9 M12.2 6.2 11 5",
  more: "M5 12h.01 M12 12h.01 M19 12h.01",
  external: "M15 3h6v6 M10 14 21 3 M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
  copy: "M9 9h11v11H9z M5 15H4V4h11v1",
  trash: "M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14",
  edit: "M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z",
  key: "M15 7a4 4 0 1 1-3.9 5H3v3h3v3h3v-3h2.1A4 4 0 0 1 15 7z",
  webhook: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2 M6 17l3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06 M12 6l3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8",
  card: "M2 6h20v12H2z M2 10h20",
  upload: "M12 15V3 M7 8l5-5 5 5 M4 15v6h16v-6",
  download: "M12 3v12 M7 10l5 5 5-5 M4 15v6h16v-6",
  file: "M14 3H6v18h12V7z M14 3v4h4",
  tag: "M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01",
  star: "M12 3l2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9z",
  logout: "M9 21H5V3h4 M16 17l5-5-5-5 M21 12H9",
  eye: "M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  sparkle: "M12 3l1.9 5.6L19.5 10.5l-5.6 1.9L12 18l-1.9-5.6-5.6-1.9 5.6-1.9z",
  minus: "M5 12h14",
  flame: "M12 3c1 4-3 5-3 8 0 1 1 2 2 2-1-3 3-4 3-7 4 4 6 7 4 11a7 7 0 0 1-12-1c-1-4 2-6 6-13z",
  home: "M3 10l9-7 9 7v11H3z M9 21v-8h6v8",
  filter: "M3 5h18 M6 12h12 M9 19h6",
  calendar: "M4 5h16v16H4z M8 2v6 M16 2v6 M4 10h16",
  arrowRight: "M4 12h16 M14 6l6 6-6 6",
  arrowLeft: "M20 12H4 M10 6l-6 6 6 6",
  help: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4 M12 17h.01",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4",
  shield: "M12 3l9 4c0 7-3 11-9 14C6 18 3 14 3 7z M8 12l3 3 5-6",
  chevronUp: "M6 15l6-6 6 6",
  menu: "M4 6h16 M4 12h16 M4 18h16",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = "md", className = "", style }: { name: IconName; size?: "sm" | "md" | number; className?: string; style?: CSSProperties }) {
  return (
    <svg className={`ico${size === "sm" ? " s" : ""}${className ? ` ${className}` : ""}`} viewBox="0 0 24 24" aria-hidden="true" style={typeof size === "number" ? { width: size, height: size, ...style } : style}>
      <path d={PATHS[name]} />
    </svg>
  );
}

/** Hearth enclosure with the Ember flame. */
export function Logo({ size = 22, wordmark = false }: { size?: number; wordmark?: boolean }) {
  return (
    <span className="hearth-logo" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <path d="M7 27V15a9 9 0 0 1 18 0v12 M4 27h24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <path d="M16 25c-2.6 0-4.4-1.8-4.4-4.1 0-2.8 2.5-4 3.3-6.5 1.4 1.3 1.9 2.5 1.9 3.6.9-.6 1.5-1.5 1.7-2.5 1.5 1.3 2.3 3.1 2.3 5 0 2.6-2 4.5-4.8 4.5z" fill="var(--acc, #FFC53D)" stroke="var(--ai-fg, #AB6400)" strokeWidth="1" strokeLinejoin="round" />
      </svg>
      {wordmark && <span style={{ fontFamily: "'Bricolage Grotesque', 'Figtree', sans-serif", fontWeight: 600, letterSpacing: "-0.045em", fontSize: size * 0.8 }}>hearthdesk</span>}
    </span>
  );
}

export function EmberMark({ size = 24 }: { size?: number }) {
  return <span className="ember-mark" role="img" aria-label="Ember" style={{ width: size, height: size }}><Icon name="ai" /></span>;
}
